import type { ListEmptyStateProps } from "./types-list";
import { useList } from "./use-list";
import { ListEmptyStateView } from "./view-list";

/**
 * Atalho do `EmptyState` para listagens: escolhe ilustração e textos pelo `kind` e mostra "Limpar" só com
 * busca ou filtros aplicados. `title` e `description` sobrescrevem os textos gerados.
 */
export function ListEmptyState(props: ListEmptyStateProps) {
  return <ListEmptyStateView {...useList(props)} />;
}
ListEmptyState.displayName = "ListEmptyState";
